import {
	ADD_PASSENGER,
	PassengerAction,
	REMOVE_PASSENGER,
	SET_PASSENGERS,
	SetPassengersAction,
	CLEAR_PASSENGERS
} from './actions';

export const MAX_PASSENGERS_COUNT = 9;

export interface PassengersState {
	[passengerType: string]: number;
}

const defaultState: PassengersState = {
	ADT: 1,
	PDA: 0, // hidden in core by css
	CLD: 0,
	INF: 0,
	INS: 0
};

export const passengersReducer = (
	state: PassengersState = defaultState,
	{ payload, type }: PassengerAction | SetPassengersAction
) => {
	switch (type) {
		case ADD_PASSENGER: {
			const { passengerType, modifyCount = 1 } = payload;

			return {
				...state,
				...{
					[passengerType]: state[passengerType] = (state[passengerType] || 0) + modifyCount
				}
			};
		}

		case REMOVE_PASSENGER: {
			const { passengerType, modifyCount = 1 } = payload;

			return {
				...state,
				...{ [passengerType]: state[passengerType] -= modifyCount }
			};
		}

		case SET_PASSENGERS:
			return {
				...state,
				...(payload as PassengersState)
			};

		case CLEAR_PASSENGERS:
			for (const passengerType in state) {
				state[passengerType] = 0;
			}

			return {
				...state
			};

		default:
			return state;
	}
};
